/**
 * File Utility Functions
 * Helper functions for file type detection and handling
 */

/**
 * Determines the file type based on file extension
 * @param {string} fileName - The name of the file
 * @returns {string} - File type: 'pdf', 'image', 'video', 'document', or 'unknown'
 */
export const getFileType = (fileName) => {
  if (!fileName) return 'unknown'
  const ext = fileName.toLowerCase().split('.').pop()

  if (['pdf'].includes(ext)) return 'pdf'
  if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp'].includes(ext)) return 'image'
  if (['mp4', 'webm', 'ogg'].includes(ext)) return 'video'
  if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'].includes(ext)) return 'document'

  return 'unknown'
}
